import { apiGet, apiPost, apiPatch, apiDelete } from './client';
import type { CompanyBot } from '../types';

export async function getBots(): Promise<CompanyBot[]> {
  return apiGet<CompanyBot[]>('/telegram/bots');
}

export async function createBot(data: {
  botToken: string;
  username: string;
  companyId?: string;
}): Promise<CompanyBot> {
  return apiPost<CompanyBot>('/telegram/bots', data);
}

export async function updateBot(id: string, data: {
  botToken?: string;
  username?: string;
  webhookUrl?: string;
  isActive?: boolean;
  companyId?: string;
}): Promise<CompanyBot> {
  return apiPatch<CompanyBot>(`/telegram/bots/${id}`, data);
}

export async function deleteBot(id: string): Promise<void> {
  return apiDelete<void>(`/telegram/bots/${id}`);
}

export async function sendTelegramMessage(botId: string, chatId: string, text: string, companyId?: string): Promise<unknown> {
  return apiPost<unknown>(`/telegram/bots/${botId}/send-message`, { chatId, text, companyId });
}
